import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { Table, Col, Row, Card, Typography } from "antd";
import { withdrawList } from "../../redux/slice/passbookSlice";
import FormattedDate from "../helper/Date";


const { Title } = Typography;

export default function WithdrawTable() {
  const dispatch = useDispatch();
  const [tableParams, setTableParams] = useState({
    pagination: { current: 1, pageSize: 5, total: 0 },
  });

  useEffect(() => {
    dispatch(withdrawList({ page: tableParams.pagination.current, limit: tableParams.pagination.pageSize }));
  }, [dispatch, tableParams.pagination.current]);

  const { withdrawListData = {}, loading } = useSelector((state) => state.passbook);
  console.log("listWithdrawData", withdrawListData);

  // Handle response structure: { success, data: { withdrawals: [], pagination: {} } }
  const withdrawals = withdrawListData?.data?.withdrawals || withdrawListData?.data || [];
  const pagination = withdrawListData?.data?.pagination || {};
  const { total = 0, page = 1, limit = 5 } = pagination;
  
  useEffect(() => {
    if (total > 0) {
      setTableParams((prev) => ({
        ...prev,
        pagination: { ...prev.pagination, total: total, pageSize: limit, current: page },
      }));
    }
  }, [total, page, limit]);

  const handleTablePageChange = (pagination) => {
    setTableParams({
      pagination: { ...pagination },
    });
  };

  const columns = [
    {
      title: <Title level={5}>Payment Method</Title>,
      dataIndex: "paymentMethod",
      key: "paymentMethod",
      render: (text) => <span style={{ fontSize: "12px" }}>{text || "-"}</span>,
    },
    {
      title: <Title level={5}>Amount</Title>,
      dataIndex: "amount",
      key: "amount",
      render: (data) => <span style={{ fontSize: "12px" }}>{data}</span>,
    },
    {
      title: <Title level={5}>Currency</Title>,
      dataIndex: "currency",
      key: "currency",
      render: (data) => <span style={{ fontSize: "12px" }}>{data}</span>,
    },
    {
      title: <Title level={5}>Requested At</Title>,
      dataIndex: "createdAt",
      key: "createdAt",
      render: (data) => <span style={{ fontSize: "12px" }}><FormattedDate value={data} /></span>,
    },
    {
      title: <Title level={5}>Status</Title>,
      dataIndex: "status",
      key: "status",
      render: (data) => <span style={{ fontSize: "12px" }}>{data}</span>,
    },
  ];

  return (
    <>
      {Array.isArray(withdrawals) && withdrawals.length > 0 && (
        <div className="site-card-wrapperr2" style={{ marginTop: "2%" }}>
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Card
                bordered={false}
                title={<Title level={4}>Withdraw </Title>}
                className="criclebox tablespace mb-24"
              >
                <div className="table-responsive2">
                  <div className="table-container2">
                    <Table
                      columns={columns}
                      dataSource={withdrawals}
                      pagination={tableParams.pagination}
                      loading={loading}
                      rowKey={(record) => record._id || record.id}
                      onChange={handleTablePageChange}
                      className="ant-border-space"
                    />
                  </div>
                </div>
              </Card>
            </Col>
          </Row>
        </div>
      )}
    </>
  );
}
